module.exports = __webpack_public_path__ + "media/images/riders/REMI_THIRION-ccfd0040b3f3164bfc56343283afae14.png";